/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaVectorQualityDefinition from './AqaVectorQualityDefinition';

/**
 * The AqaVectorQualityDefinitionTable model module.
 * @module model/AqaVectorQualityDefinitionTable
 * @version v0
 */
export default class AqaVectorQualityDefinitionTable {
  /**
   * Constructs a new <code>AqaVectorQualityDefinitionTable</code>.
   * @alias module:model/AqaVectorQualityDefinitionTable
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVectorQualityDefinitionTable</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVectorQualityDefinitionTable} obj Optional instance to populate.
   * @return {module:model/AqaVectorQualityDefinitionTable} The populated <code>AqaVectorQualityDefinitionTable</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVectorQualityDefinitionTable();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastModifiedTimestamp'))
        obj.lastModifiedTimestamp = ApiClient.convertToType(data['lastModifiedTimestamp'], 'Number');
      if (data.hasOwnProperty('columnQualities'))
        obj.columnQualities = ApiClient.convertToType(data['columnQualities'], [AqaVectorQualityDefinition]);
      if (data.hasOwnProperty('rowQualities'))
        obj.rowQualities = ApiClient.convertToType(data['rowQualities'], [AqaVectorQualityDefinition]);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaVectorQualityDefinitionTable.prototype.id = undefined;

/**
 * @member {Number} lastModifiedTimestamp
 */
AqaVectorQualityDefinitionTable.prototype.lastModifiedTimestamp = undefined;

/**
 * @member {Array.<module:model/AqaVectorQualityDefinition>} columnQualities
 */
AqaVectorQualityDefinitionTable.prototype.columnQualities = undefined;

/**
 * @member {Array.<module:model/AqaVectorQualityDefinition>} rowQualities
 */
AqaVectorQualityDefinitionTable.prototype.rowQualities = undefined;

